import React from "react"

import { InternalError } from "pages/static"
import { FetchStatusType } from "types"

type Props = {
  fetchStatus: FetchStatusType
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: any
  renderLoading?: () => React.ReactElement
  renderError?: () => React.ReactElement
}

const LoadableCollection = ({
  fetchStatus,
  children,
  renderLoading,
  renderError,
}: Props) => {
  if (fetchStatus.isFetching) {
    if (renderLoading) {
      return renderLoading()
    } else {
      return <></>
    }
  } else if (fetchStatus.isFailed) {
    if (renderError) {
      return renderError()
    } else {
      return <InternalError />
    }
  } else {
    if (children) {
      if (typeof children === "function") {
        return children()
      } else {
        return children
      }
    } else {
      return null
    }
  }
}

export default LoadableCollection

/*
Usage:

<LoadableCollection fetchStatus={fetchStatus}>
  <SomeList />
</LoadableCollection>

or

<LoadableCollection fetchStatus={fetchStatus}>
  {() => renderCollection()}
</LoadableCollection>
*/
